import { authorizedFetch } from './api-client';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface ChatTicket {
  id: string;
  cellphone: string;
  patient_name: string;
  last_message_text: string;
  last_message_direction: string;
  status: string;
  last_message_at: string;
  clinic_id: string;
  wa_phone_number_id: string | null;
  provider: string | null;   // 'whapi' | 'meta' | 'twilio'
}

export async function fetchPendingTickets(clinicId?: string): Promise<ChatTicket[]> {
  const params = new URLSearchParams({ process_status: 'PENDING' });
  if (clinicId) params.append('clinic_id', clinicId);
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/chat-tickets/?${params.toString()}`);
  if (!response.ok) throw new Error('Erro ao buscar tickets pendentes');
  return response.json();
}

export async function resolveTicket(ticketId: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/chat-tickets/${ticketId}/resolve`, {
    method: 'POST',
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Erro ao marcar como resolvido');
  }
}

export interface ChatHistoryResponse {
  total_messages: number;
  history: {
    id: string;
    content: string;
    media_id: string;       // media_id do Whapi
    msg_type: string;       // 'image', 'audio', 'document', ''
    direction: 'IN' | 'OUT';
    created_at: string;
  }[];
}

export async function fetchChatHistory(
  ticketId: string,
  limit: number = 20,
  days: number = 7
): Promise<ChatHistoryResponse> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/chat-tickets/${ticketId}/logs?limit=${limit}&days=${days}`
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Erro ao buscar histórico de mensagens');
  }
  return response.json();
}

export async function sendMessage(ticketId: string, content: string): Promise<void> {
  const response = await authorizedFetch(`${API_BASE_URL}/api/v1/chat-tickets/${ticketId}/send`, {
    method: 'POST',
    body: JSON.stringify({ content }),
    headers: { 'Content-Type': 'application/json' }
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Erro ao enviar mensagem');
  }
}

export async function fetchMediaBlob(ticketId: string, msgType: string, mediaId: string): Promise<string> {
  const response = await authorizedFetch(
    `${API_BASE_URL}/api/v1/media/${ticketId}/${msgType}/${mediaId}`
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || 'Erro ao buscar mídia');
  }
  const blob = await response.blob();
  return URL.createObjectURL(blob);
}
